import styles from "./SearchError.module.scss";

export function SearchError({ title, text }: { title: string; text: string }) {
  return (
    <div className={styles.searchError}>
      <h2 className={styles.searchErrorTitle}>{title}</h2>
      <p className={styles.searchErrorText}>{text}</p>
    </div>
  );
}
